import { mapActions } from "vuex";

export default {
    created() {

    },
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'guardarFtn':
                            this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaPost: ['info_nomina', "nomina_devengados", "nomina_deducidos"],
                                    tablaDelete: [],
                                    notaDelete: null,
                                    tablaAuditar: true,
                                }
                            })
                            break;
                        case 'inactivarFtn':
                            await this.updateDataForm({ state: 'info_nomina/deleted_at', data: this.fecha().fecha.delete })
                            await this.updateDataForm({ state: 'info_nomina/nota_delete', data: 'Eliminar nómina' })
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaAuditar: true,
                                    notaDelete: null,
                                    tablaPost: ['info_nomina'],
                                    tablaDelete: []
                                }
                            })

                            break;

                    }
                }
                let dataSave = await this.save(event.save)

                if (event.ftn === 'guardarFtn') {
                    window.open(this.url + '/api/pdf/nomina?id=' + dataSave.ids.info_nomina.toString() + '&token=' + this.token, '_blank')
                }

                const await20 = this.resetDataIndex()
                const await21 = this.onInit()
                const await22 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await23 = this.resetGlobal({ state: 'saveConfig/saveloading' })
                const await24 = this.resetGlobal({ state: 'openModal' })

                await Promise.all([await20, await21, await22, await23, await24])

                if (event.ftn === 'inactivarFtn') {
                    await this.getFiltrar()
                }

                return true
            } catch (e) {
                console.log(e)
            }
        }
    },
}